import { Inject, Injectable, InjectionToken } from '@angular/core';
import { CacheService } from '@se/se.ui.html5';
import { SeveralSettingsBoxSettings } from 'estensa-module';
import { Observable, from } from 'rxjs';

export const ESTENSA_MODULE_SEVERAL_SETTINGS_BOX_SETTINGS_SERVICE = new InjectionToken(
    'estensa.module.several.settings.box.service',
);

@Injectable({
    providedIn: 'root',
})
export class SeveralSettingsBoxSettingsService {
    constructor(
        @Inject(ESTENSA_MODULE_SEVERAL_SETTINGS_BOX_SETTINGS_SERVICE) private settingsService,
        private cacheService: CacheService,
    ) {}

    getSettings(): Observable<SeveralSettingsBoxSettings> {
        return this.cacheService.get(
            'SeveralSettingsBoxSettings',
            from(this.settingsService.getAsJSON() as Promise<SeveralSettingsBoxSettings>),
        );
    }
}
